var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMagnifier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_6964",
    "data-name": "Group 6964",
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.502,
    height: 38.502,
    viewBox: "0 0 38.502 38.502",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_15275",
    "data-name": "Path 15275",
    d: "M33.934,26.662A15.623,15.623,0,1,0,11.84,4.568,15.319,15.319,0,0,0,9.49,23.423a.657.657,0,0,1-.091.783L1.429,32.177c-1.587,1.586-1.964,3.8-.557,5.212l.242.242c1.407,1.407,3.625,1.03,5.212-.557L14.28,29.12a.667.667,0,0,1,.8-.107A15.319,15.319,0,0,0,33.934,26.662Zm-19.21-2.884a11.544,11.544,0,1,1,16.325,0A11.557,11.557,0,0,1,14.725,23.778Z",
    transform: "translate(-0.001 0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6963",
    "data-name": "Group 6963",
    transform: "translate(14.109 6.252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15276",
    "data-name": "Path 15276",
    d: "M115.364,58.845A1.613,1.613,0,0,1,113.88,56.6a10.162,10.162,0,0,1,13.3-5.392,1.612,1.612,0,1,1-1.257,2.97,6.934,6.934,0,0,0-9.077,3.679A1.613,1.613,0,0,1,115.364,58.845Z",
    transform: "translate(-113.752 -50.409)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifier);
export default __webpack_public_path__ + "static/media/magnifier.49527f5f.svg";
export { ForwardRef as ReactComponent };